import React from "react";
import { Outlet } from "react-router-dom";

const Main = () => {
  return (
    <div className="bg-[#511b1d] h-screen">
      <Outlet />
    </div>
  );
};

export default Main;
